import { useMemo } from 'react'
import FirestoreUser from '../../../../types/FirestoreUser'
import { calculateAge } from '../../../../utils/calculateAge'
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip as ChartTooltip,
  Legend,
  Title,
} from 'chart.js'

// Import our context provider and component
import { DentalFormProvider } from './context/DentalFormContext'
import DentalForm from './components/DentalForm'

// Register Chart.js components
ChartJS.register(ArcElement, ChartTooltip, Legend, Title)

interface Props {
  uid: string
  firestoreUser: FirestoreUser
}

/**
 * Main component for the Dental Details tab
 * Acts as a thin wrapper that sets up the context and provides the form
 */
const DentalTab = ({ uid, firestoreUser }: Props) => {
  // Calculate user age from profile
  const userAge = useMemo(() => {
    const birthDate = firestoreUser.profile?.birthDate
    if (!birthDate) return undefined
    return calculateAge(birthDate)
  }, [firestoreUser])

  return (
    <DentalFormProvider
      initialValues={firestoreUser.dentalDetails || {}}
      userAge={userAge}
    >
      <DentalForm uid={uid} />
    </DentalFormProvider>
  )
}

export default DentalTab